export function generateNumArr(loopStart, loopMax) {
    var numArr = [];
    for (var i = loopStart; i <= loopMax; i++) {
        numArr.push(i);
    }
    return numArr;
}
